(() => {
  const SELECTOR = '[data-special-sale]';

  class ProtacticSpecialSale {
    constructor(root) {
      this.root = root;
      this.start = this.parseDate(root.dataset.start);
      this.end = this.parseDate(root.dataset.end);
      this.state = '';
      this.timer = null;
      this.bindFilters();
      this.bindSmoothScroll();
      this.tick();
      this.timer = window.setInterval(() => this.tick(), 1000);
    }

    parseDate(value) {
      if (!value) return null;
      const normalized = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(value) ? value : `${value}-06:00`;
      const date = new Date(normalized);
      return Number.isNaN(date.getTime()) ? null : date;
    }

    getState(now) {
      if (!this.start || !this.end) return 'pre';
      if (now < this.start) return 'pre';
      if (now <= this.end) return 'active';
      return 'ended';
    }

    tick() {
      const now = new Date();
      const nextState = this.getState(now);
      if (nextState !== this.state) this.setState(nextState);

      if (nextState === 'ended') {
        this.updateCountdown(0);
        if (this.timer) window.clearInterval(this.timer);
        return;
      }

      const deadline = nextState === 'pre' ? this.start : this.end;
      this.updateCountdown(Math.max(0, deadline.getTime() - now.getTime()));
    }

    setState(state) {
      this.state = state;
      this.root.dataset.campaignCurrent = state;
      this.root.querySelectorAll('[data-campaign-state]').forEach((element) => {
        element.hidden = element.dataset.campaignState !== state;
      });
    }

    updateCountdown(milliseconds) {
      const totalSeconds = Math.floor(milliseconds / 1000);
      const values = {
        days: Math.floor(totalSeconds / 86400),
        hours: Math.floor((totalSeconds % 86400) / 3600),
        minutes: Math.floor((totalSeconds % 3600) / 60),
        seconds: totalSeconds % 60
      };

      this.root.querySelectorAll('[data-countdown-output]').forEach((output) => {
        Object.entries(values).forEach(([unit, value]) => {
          const target = output.querySelector(`[data-time-${unit}]`);
          if (target) target.textContent = String(value).padStart(2, '0');
        });
        output.setAttribute('aria-label', `${values.days} días, ${values.hours} horas, ${values.minutes} minutos y ${values.seconds} segundos`);
      });
    }

    bindFilters() {
      const buttons = this.root.querySelectorAll('[data-sale-filter]');
      const products = this.root.querySelectorAll('[data-sale-category]');
      const empty = this.root.querySelector('[data-sale-empty]');
      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const filter = button.dataset.saleFilter;
          let visible = 0;
          buttons.forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
          products.forEach((product) => {
            const show = filter === 'all' || product.dataset.saleCategory === filter;
            product.hidden = !show;
            if (show) visible += 1;
          });
          if (empty) empty.hidden = visible > 0;
        });
      });
    }

    bindSmoothScroll() {
      this.root.querySelectorAll('[data-smooth-scroll]').forEach((link) => {
        link.addEventListener('click', (event) => {
          const target = this.root.querySelector(link.getAttribute('href'));
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
          window.setTimeout(() => target.focus({ preventScroll: true }), 450);
        });
      });
    }

    destroy() {
      if (this.timer) window.clearInterval(this.timer);
    }
  }

  const initialize = (scope = document) => {
    scope.querySelectorAll(SELECTOR).forEach((root) => {
      if (root.__ptcSpecialSale) root.__ptcSpecialSale.destroy();
      root.__ptcSpecialSale = new ProtacticSpecialSale(root);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.querySelector(SELECTOR);
    if (root?.__ptcSpecialSale) root.__ptcSpecialSale.destroy();
  });
})();
